import { render } from "./BcaAnimationView.vue?vue&type=template&id=da6cb93e"
import script from "./BcaAnimationView.vue?vue&type=script&lang=js"
export * from "./BcaAnimationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__